import api, { handleError } from "../index";

export const activeUserCouponsService = (apiToken) =>
  api({
    method: "get",
    headers: {
      ...api.defaults.headers,
      Authorization: `Bearer ${apiToken}`,
    },
    url: `/users/active-user-coupons`,
  })
    .then((response = {}) => {
      return { error: null, data: response.data.data };
    })
    .catch((error) => {
      const errorPayload = handleError(error);
      return {
        ...errorPayload,
        data: null,
      };
    });
